import { render, staticRenderFns } from "./BUN.vue?vue&type=template&id=5b7b95e2&scoped=true"
import script from "./BUN.vue?vue&type=script&lang=js"
export * from "./BUN.vue?vue&type=script&lang=js"
import style0 from "./BUN.vue?vue&type=style&index=0&id=5b7b95e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b95e2",
  null
  
)

export default component.exports